import { AxiosInstance } from 'axios'

/* Types */
import { MakeWok, WokState } from '@/types/api/api-v3/make-wok'

import {
  HttpStatusCode,
  NotFoundError,
  ServerError,
  Success,
} from '~/api/results'

const defaultState: WokState = {
  page: {
    breadcrumbs: [],
    categories: [],
    products: [],
    seo: {
      seo_description: undefined,
      seo_keywords: undefined,
      seo_title: undefined,
    },
  },
  compositionOfWok: {},
}

export function createWokService({
  axios,
  sentry,
  city,
}: {
  axios: AxiosInstance
  sentry: any
  city: string
  hostname: string
}) {
  // Формируем новый url для v4
  const baseUrlV4 = getApiBaseUrl(city, 4)

  return {
    async fetchPage() {
      try {
        const { data } = await axios.get<MakeWok>(
          `${baseUrlV4}/wok_constructor/`,
        )

        const page: MakeWok = {
          breadcrumbs: data.breadcrumbs || defaultState.page.breadcrumbs,
          categories: data.categories || defaultState.page.categories,
          products: data.products || defaultState.page.products,
          seo: {
            seo_description:
              data.seo?.seo_description ||
              defaultState.page.seo.seo_description,
            seo_keywords:
              data.seo?.seo_keywords || defaultState.page.seo.seo_keywords,
            seo_title: data.seo?.seo_title || defaultState.page.seo.seo_title,
          },
        }

        return new Success(page)
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Страница не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('Что-то пошло не так')
        }
      }
    },
  }
}
